import React from "react";

type Props = {
  className?: string;
  orientation?: "horizontal" | "vertical";
} & React.HTMLAttributes<HTMLDivElement>;

const Divider = ({ className, orientation = "horizontal", ...props }: Props) => {
  return (
    <div
      className={`${orientation === "horizontal" ? "w-full h-[1px]" : "w-[1px] h-full"} bg-ultraLightGray ${className}`}
      {...props}
    ></div>
  );
};

export default Divider;
